import { IPublication } from "@opengov/stories-shared/types";
import { transport } from "@opengov/app-core/transport";

export const sendPublicationViewedActivity = (publication: IPublication, userUuid: string, entityId: number): void => {
  const message = {
    id: crypto.randomUUID(),
    source: "urn:opengov:service/stories-service",
    specversion: "1.0",
    type: "com.opengov.user-activity.v1.view",
    datacontenttype: "application/json",
    time: new Date().toISOString(),
    subject: userUuid,
    data: {
      userActivity: {
        itemUrn: `urn:opengov:stories:publication/${publication.id}`,
        userId: userUuid,
        entityId: entityId,
        activityTime: new Date().toISOString(),
        itemUrl: window.location.href,
        itemName: publication.title,
        itemType: 'Publication',
        itemId: publication.id,
      }
    }
  };
  void transport
    .url('/user_activity_service/stories')
    .json(message)
    .post();
}
